import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import ApproverMssPanel from "./ApproverMssPanel";
import "./managerSelfService.scss";

const AdminManagerSelfService: React.FC = () => {
  return (
    <div className="page-wrapper mss-container">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Manager Self-Service</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Services</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Manager Self-Service
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <ApproverMssPanel />
      </div>
    </div>
  );
};

export default AdminManagerSelfService;
